import {FC} from "react";
import {AutoSizer} from "react-virtualized";
import {FixedSizeList} from "react-window";
import {PatrolLastEntriesListRow} from "./row";
import {EmptyState} from "../../../../components/state/empty";
import {UserPatrol} from "../../../../../domain/patrol/Patrol";

type Props = {
    entries?: UserPatrol[];
};

export const PatrolLastEntriesList: FC<Props> = ({entries}) => {
    return !!entries && entries.length > 0 ? (
        //@ts-ignore
        <AutoSizer>
            {({width, height}) => (
                <FixedSizeList
                    itemSize={85}
                    height={height}
                    itemCount={entries.length}
                    width={width}
                    itemData={{entries}}
                >
                    {PatrolLastEntriesListRow}
                </FixedSizeList>
            )}
        </AutoSizer>
    ) : (
        <EmptyState/>
    );
};
